import { Credentials, config } from 'aws-sdk/global';
import Kinesis from 'aws-sdk/clients/kinesis';
import { assembleKinesisConfig, assembleStreamConfigs } from './config';
import Fetcher from '../util/Fetcher';
export var buildKinesisConfiguration = function buildKinesisConfiguration(_ref) {
  var configuration = _ref.configuration,
    credentials = _ref.credentials;
  var serverTime = configuration.server_time;
  if (serverTime) config.systemClockOffset = Date.parse(serverTime) - Date.now();
  return {
    client: buildKinesisClient(configuration, credentials),
    proxyDomain: configuration.proxy_domain,
    streamConfigs: assembleStreamConfigs(configuration)
  };
};
export var buildKinesisClient = function buildKinesisClient(configuration, credentials) {
  var kinesisConfig = Object.assign({}, assembleKinesisConfig(configuration.client_configuration), {
    credentials: credentials
  });
  return new Kinesis(kinesisConfig);
};
export var buildCredentials = function buildCredentials(credentialParams) {
  var creds = new Credentials(credentialParams.access_key_id, credentialParams.secret_access_key, credentialParams.session_token) // credentialParams
  ;
  creds.expireTime = Date.parse(credentialParams.expiration);
  return creds;
};
var getKinesisConfig = function getKinesisConfig(quizSessionId) {
  var fetcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Fetcher();
  return new Promise(function (resolve, reject) {
    var url = "/api/quiz_sessions/".concat(quizSessionId, "/kinesis_credentials");
    fetcher.post(url).then(function (configuration) {
      var config = buildKinesisConfiguration({
        configuration: configuration,
        credentials: buildCredentials(configuration.credentials)
      });
      resolve(config);
    }).then(function (err) {
      return reject(err);
    });
  });
};
export default getKinesisConfig;